import { onLoad } from '@demant/wdh';
window.DGS = {};
window.DGS.getConfiguration = function () {
  var script = document.currentScript || function () {
      var scripts = document.getElementsByTagName('script[type="application/json"]');
      return scripts[scripts.length - 1];
    }(),
    configurationId,
    $configuration,
    configuration;
  configurationId = $(script).data('configuration-id');
  $configuration = configurationId !== undefined ? $("[data-configuration='".concat(configurationId, "']")) : undefined;
  configuration = $configuration !== undefined && $configuration.length ? JSON.parse($configuration.html()) : {};
  return configuration;
};
window.DGS.OnLoad = {
  getInstance: function getInstance() {
    return {
      register: function register(callback) {
        onLoad(callback);
      }
    };
  }
};